module.exports = __webpack_public_path__ + "static/media/growing_new_farmers_desktop.59cd94af.jpg";